import React from 'react'
import styled from 'styled-components'
import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter
} from 'reactstrap'
import {
  injectIntl,
  FormattedMessage
} from 'react-intl'

import Button, { RawButton } from '../../atoms/Button'
import ResearchTerritorySelector from '../ResearchTerritorySelector'
import Loading from '../../atoms/Loading'

const StyledModal = styled(Modal)`
  @media (min-width: 576px) {
    max-width: 880px !important
  }
`

const SmallLoading = styled(Loading)`
  max-height: 32px;
  max-width: 32px;
`

class ResearchAddTerritoryModal extends React.PureComponent {
  static defaultProps = {
    isAddDisabled: true,
    isAddAllDisabled: true,
    isLoadingAddAll: false,
    isOpen: false,
    onAddAllClick: (_ids) => {},
    onAddClick: (_id) => {},
    toggle: () => {}
  }

  render() {
    return (
      <div>
        <StyledModal isOpen={ this.props.isOpen } toggle={ this.props.toggle }>
          <ModalHeader toggle={ this.props.toggle } />
          <ModalBody>
            <ResearchTerritorySelector />
          </ModalBody>
          <ModalFooter>
            <Button
              disabled={ this.props.isAddDisabled }
              onClick={ this.props.onAddClick }
            >
              survey.territories.button_modal_add_territory
            </Button>
            {' '}
            <RawButton
              disabled={ this.props.isAddAllDisabled }
              onClick={ this.props.onAddAllClick }
            >
              {
                this.props.isLoadingAddAll ?
                  <SmallLoading /> :
                  this.props.intl.formatMessage({
                    id: 'survey.territories.button_modal_add_all_territories'
                  })
              }
            </RawButton>
          </ModalFooter>
        </StyledModal>
      </div>
    )
  }
}

export default injectIntl(ResearchAddTerritoryModal)



// WEBPACK FOOTER //
// ./src/components/organisms/ResearchAddTerritoryModal/ResearchAddTerritoryModal.js